<template>
  <div>
    <div class="initial" v-if="!initialFlag">
      <div class="load-bg">
        <div class="load">
          <hr>
          <hr>
          <hr>
          <hr>
          <div class="loadback"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="adminView || partnerView">
        <div v-if="currentUser!=null">
          <div v-if="publicRoute">
            <link rel="stylesheet" type="text/css" href="/static/front/bootstrap/dist/css/bootstrap.min.css">
            <BusinessPanel class="test1"></BusinessPanel>
            <PublicPanel class="test2"></PublicPanel>
          </div>
          <div v-else>
            <link rel="stylesheet" type="text/css" href="/static/admin/bootstrap/css/bootstrap.min.css">
            <AdminPanel v-if="adminView"></AdminPanel>
            <PartnerPanel v-if="partnerView"></PartnerPanel>
          </div>
        </div>
      </div>
      <div v-else>
        <link rel="stylesheet" type="text/css" href="/static/front/bootstrap/dist/css/bootstrap.min.css">
        <EmailVerify v-if="verifyEmailRoute"></EmailVerify>
        <BusinessPanel v-if="(businessView || publicRoute) && !verifyEmailRoute"></BusinessPanel>
        <Login v-if="currentUser==null && !publicRoute && !widgetRoute && !forgotPasswordRoute && !verifyEmailRoute"></Login>
        <ForgotPassword
          v-if="currentUser==null && !publicRoute && !widgetRoute && forgotPasswordRoute"></ForgotPassword>
        <TrialRegistration v-if="trialUserRoute"></TrialRegistration>
        <PublicPanel v-if="publicRoute"></PublicPanel>
        <WidgetsPanel v-if="widgetRoute"></WidgetsPanel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from './store'
import Login from './components/Login.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import BusinessPanel from './components/BusinessPanel.vue'
import WidgetsPanel from './components/WidgetsPanel.vue'
import AdminPanel from './components/AdminPanel.vue'
import PartnerPanel from './components/PartnerPanel.vue'
import PublicPanel from './components/PublicPanel.vue'
import EmailVerify from './components/EmailVerify.vue'
import TrialRegistration from './components/trial-registration/list.vue'
import config from './config/app'
import axios from 'axios'
// import * as VeeValidate from 'vee-validate'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

VeeValidate.Validator.extend('password_format', {
  getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number`,
  validate: value => {
    if (value.length < 8) {
      document.getElementById('passerror').style.display = 'block'
      return false
    } else {
      var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])')
      // var strongRegex = new RegExp('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&-+=()])(?=\\S+$).{8, 20}$')
      if (strongRegex.test(value)) {
        document.getElementById('passerror').style.display = 'none'
        return true
      } else {
        document.getElementById('passerror').style.display = 'block'
        return false
      }
    }
  }
})

export default {
  computed: {
    initialFlag () {
      if (this.$store.getters.initialFlag) {
        if (this.$route.name === 'home' && !store.getters.currentUser) {
          location.href = config.host + '/login'
        } else {
          if (store.getters.currentUser && this.$route.name === 'login') {
            location.href = config.host
          }
          return this.$store.getters.initialFlag
        }
      }
    },
    currentUser () {
      let user = this.$store.getters.currentUser
      // restore giving cart
      let companyId = user && user.user_business && user.user_business.company_id && user.account === 'company' ? user.user_business.company_id : null
      store.dispatch('restoreGivingCart', {id: user ? user.id : null, company_id: companyId})
      // setInterval(() => {
      //   if (user) {
      //     store.dispatch('restoreGivingCart', {id: user ? user.id : null, company_id: companyId})
      //   }
      // }, 10000)
      if (user) {
        document.body.classList.add('custUserLoginBody')
      } else {
        document.body.classList.remove('custUserLoginBody')
      }
      return user
    },
    oauthToken () {
      return this.$store.getters.oauthTokens
    },
    adminView () {
      return this.$store.getters.currentUser !== null && this.$store.getters.currentUser.type === 'admin' && this.$route && ((this.$route.name) ? this.$route.name.indexOf('widget-raw') : '') === -1
    },
    partnerView () {
      return this.$store.getters.currentUser !== null && this.$store.getters.currentUser.type === 'partner' && ((this.$route.name) ? this.$route.name.indexOf('widget-raw') : '') === -1
    },
    businessView () {
      return this.$store.getters.currentUser !== null && this.$store.getters.currentUser.type === 'business' && ((this.$route.name) ? this.$route.name.indexOf('widget-raw') : '') === -1
    },
    verifyEmailRoute () {
      return this.$route && this.$route.name && (
        this.$route.name.indexOf('verify-email') > -1
      )
    },
    widgetRoute () {
      return this.$route && ((this.$route.name) ? this.$route.name.indexOf('widget-raw') : '') > -1
    },
    publicRoute () {
      return this.$route && this.$route.name && (
        this.$route.name.indexOf('public') > -1 ||
        this.$route.name.indexOf('projectdetail') > -1 ||
        this.$route.name.indexOf('bundledetail') > -1 ||
        this.$route.name.indexOf('wcuprofile') > -1 ||
        this.$route.name.indexOf('wcu_partner') > -1 ||
        this.$route.name.indexOf('public_cart') > -1 ||
        this.$route.name.indexOf('personal-account-profile') > -1 ||
        this.$route.name.indexOf('business-account-profile') > -1 ||
        this.$route.name.indexOf('view-all-projects') > -1 ||
        this.$route.name.indexOf('business-listing') > -1 ||
        this.$route.name.indexOf('business-profile') > -1 ||
        this.$route.name.indexOf('public-join-teammember') > -1 ||
        this.$route.name.indexOf('business-members') > -1 ||
        this.$route.name.indexOf('my-hive') > -1 ||
        this.$route.name.indexOf('payment-redirect') > -1 ||
        this.$route.name.indexOf('campaign-payment-success') > -1 ||
        this.$route.name.indexOf('events') === 0 ||
        this.$route.name.indexOf('refer-a-project') > -1
      )
    },
    forgotPasswordRoute () {
      return this.$route && this.$route.name && (
        this.$route.name.indexOf('forgot-password') > -1
      )
    },
    trialUserRoute () {
      return this.$route && this.$route.path && (
        this.$route.path.indexOf('/trial-registration') > -1
      )
    }
  },
  watch: {
    oauthToken (token) {
      if (token == null) {
        localStorage.removeItem('token')
      } else {
        localStorage.setItem('token', token)
        store.dispatch('getCurrentUser')
        store.dispatch('getRoles')
      }
    }
  },
  created: () => {
    // let userBody = this.store.getters.currentUser
    let currentUserPromise = null
    // let rolesPromise = null
    let token = localStorage.getItem('impersonate-token') !== null ? localStorage.getItem('impersonate-token') : localStorage.getItem('token')
    if (token) {
      axios.interceptors.request.use(function (config) {
        if (token) {
          // console.log(JSON.parse(token).access_token)
          // config.headers.authorization = 'Bearer ' + JSON.parse(token).access_token
          config.headers.authorization = token
          config.headers.accept = 'application/json'
        }
        return config
      })
      if (!localStorage.getItem('impersonate-token')) {
        store.dispatch('restoreTokens', token)
      }

      if (store.getters.getCurrentUser == null) {
        currentUserPromise = store.dispatch('getCurrentUser')
        // rolesPromise = store.dispatch('getRoles')
      }
    }

    store.dispatch('getCountries')
    store.dispatch('initialData', [currentUserPromise])
  },
  components: {
    Login,
    AdminPanel,
    PartnerPanel,
    BusinessPanel,
    WidgetsPanel,
    PublicPanel,
    ForgotPassword,
    TrialRegistration,
    EmailVerify
  }
}
</script>

<style scoped>
div.initial {
  text-align: center;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
}

div.initial p {
  font-weight: bold;
}

.load-bg {
  height: 100%;
  display: block;
  width: 100%;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  position: fixed;
  z-index: 999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.load {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  /*change these sizes to fit into your project*/
  width: 60px;
  height: 60px;
  z-index: 10000;
}

.load hr {
  background: rgb(207, 208, 208);

  border: 0;
  margin: 0;
  width: 40%;
  height: 40%;
  position: absolute;
  border-radius: 50%;
  -webkit-animation-name: spin;
  -webkit-animation-duration: 2000ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease;
  -moz-animation-name: spin;
  -moz-animation-duration: 2000ms;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: ease;
  -ms-animation-name: spin;
  -ms-animation-duration: 2000ms;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: ease;

  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease;

  z-index: 9999;
}

.load :first-child {
  background: #47BEEE;
  animation-delay: -1.5s;
  -webkit-animation-delay: -1.5s;
  -moz-animation-delay: -1.5s
}

.load :nth-child(2) {
  background: #F03760;
  animation-delay: -1s;
  -webkit-animation-delay: -1s;
  -moz-animation-delay: -1s
}

.load :nth-child(3) {
  background: #81EAA5;
  animation-delay: -0.5s;
  -webkit-animation-delay: -0.5s;
  -moz-animation-delay: -0.5s
}

.load :nth-child(4) {
  background: #B5A7FD
}

.loadback {
  position: absolute;
  width: 10000px;
  height: 1000px;
  top: -500px;
  bottom: -9px;
  right: -1000px;
  z-index: 9998;
}

@-ms-keyframes spin {
  0%, 100% {
    -ms-transform: translate(0);
  }
  25% {
    -ms-transform: translate(160%);
  }
  50% {
    -ms-transform: translate(160%, 160%);
  }
  75% {
    -ms-transform: translate(0, 160%);
  }
}

@-moz-keyframes spin {
  0%, 100% {
    -moz-transform: translate(0);
  }
  25% {
    -moz-transform: translate(160%);
  }
  50% {
    -moz-transform: translate(160%, 160%);
  }
  75% {
    -moz-transform: translate(0, 160%);
  }
}

@-webkit-keyframes spin {
  0%, 100% {
    -webkit-transform: translate(0);
  }
  25% {
    -webkit-transform: translate(160%);
  }
  50% {
    -webkit-transform: translate(160%, 160%);
  }
  75% {
    -webkit-transform: translate(0, 160%);
  }
}

@keyframes spin {
  0%, 100% {
    transform: translate(0);
  }
  25% {
    transform: translate(160%);
  }
  50% {
    transform: translate(160%, 160%);
  }
  75% {
    transform: translate(0, 160%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue